<template>
    <div class="word_box">
      <p class="word_title">公司委托授权书</p>
      <p><strong>致： 大陆云盾电子认证服务有限公司 </strong></p>
      <p class="indent">
        本机构已充分理解并同意《大陆云盾数字证书服务协议》的全部条款，现授权下述被授权人前往贵机构办理数字证书相关业务，并愿承担相应的法律后果。具体授权内容如下：
      </p>
      <div class="indent">
        <p><strong>一、本机构信息</strong></p>
        <p><span class="line-title">机构名称：</span><span class="underline">{{license.enterpriseName}}</span></p>
        <p><span class="line-title">统一社会信用代码：</span><span class="underline">{{license.businessLicenseNo}}</span></p>
        <p><span class="line-title">法定代表人/负责人姓名：</span><span class="underline">{{license.enterpriseController}}</span></p>

        <p><strong>二、被授权人信息</strong></p>
        <el-form class="list_ul list_right" :model="grantAuth" :rules="formRules" ref="formRef">
          <p>
            <span class="line-title">姓名：</span><span class="underline" style="width: 60%;">
            <el-form-item class="list_li" prop="enterpriseController11" style="margin-bottom: 0">
              <el-input ref="nameFocusRef" :autofocus="true" size="mini" v-model.trim="grantAuth.enterpriseController11" placeholder="请输入被授权人名称"></el-input>
            </el-form-item>
          </span></p>
          <p>
            <span class="line-title">身份证号码：</span>
            <span class="underline" style="width: 60%;">
              <el-form-item class="list_li" prop="IDCard11" style="margin-bottom: 0" v-if="isInLand">
                <el-input size="mini" v-model.trim="grantAuth.IDCard11" placeholder="请输入被授权人身份证号"></el-input>
              </el-form-item>
              <el-form-item class="list_li" style="margin-bottom: 0" v-else>
                <el-input size="mini" v-model.trim="grantAuth.IDCard11" placeholder="请输入被授权人证件号码"></el-input>
              </el-form-item>
            </span>
          </p>
          <p>
            <span class="line-title" style="width: 60%;">手机号码（账号绑定、接收短信通知和校验信息指定渠道）：</span>
            <span class="underline" style="margin-left: 31%;width: 60%;">
              <el-form-item class="list_li" prop="bankLinkPhone11" style="margin-bottom: 0" v-if="isInLand">
                <el-input size="mini" v-model.trim="grantAuth.bankLinkPhone11" :maxlength="11" :minlength="11" placeholder="请输入被授权人联系电话"></el-input>
              </el-form-item>
              <el-form-item class="list_li" prop="bankLinkEmail" style="margin-bottom: 0" v-else>
                <el-input size="mini" v-model.trim="grantAuth.bankLinkEmail" placeholder="请输入被授权人联系邮箱"></el-input>
              </el-form-item>
            </span>
          </p>
        </el-form>
        <p><strong>三、授权内容</strong></p>
        <p>1．进行机构实名认证；</p>
        <p>2．进行机构数字证书申请、下载、更新、撤销及签名私钥托管等操作；</p>
        <p>3．使用数字认证进行电子签名、电子签章、身份认证及数据加解密等操作。</p>

        <p><strong>四、授权期限</strong></p>
        <p>自本授权书加盖本机构公章之日起至数字证书有效期截止之日止。以上授权转让无效。</p>
        <p><strong>本机构郑重承诺：</strong></p>
        <p>1.本机构充分知悉上述委托授权的法律意义及由此产生的法律结果，确认作出上述授权并承担法律责任。
          同时，保证提交的机构信息和资料真实、准确、完整和有效，其扫描件与原件具有同等法律效力。
        </p>
        <p>
          2.本机构如因业务需要将数字证书对应的签名私钥委托第三方平台保管，且采用免意愿认证的方式进行私钥签名操作，
          相关使用风险及后果均由本机构承担。
        </p>
        <p><strong>数字证书使用风险提示：</strong></p>
        <p>
          1.数字证书对应的签名私钥是实现可靠电子签名的核心制作数据与身份凭证，
          直接关系到签名的真实性、完整性与不可否认性。贵机构应自行生成并妥善保管签名私钥。
        </p>
        <p>
          2.如因业务需要将签名私钥委托第三方平台保管（即“私钥托管”），
          请务必在私钥托管前充分评估安全风险，并与该第三方签订书面服务协议，明确约定私钥调用权限、签署流程及责任划分等事项。
        </p>
        <p>
          3.大陆云盾依法签发及管理数字证书，对贵机构选择委托第三方托管私钥的行为不承担审查或担保义务。
          因第三方原因导致私钥被未经授权使用、篡改或泄露的，相关法律后果及经济损失由贵机构与该第三方自行协商处理，
          大陆云盾不承担任何连带责任。
        </p>
      </div>
      <div class="word-end">
        <div class="sufix">
          <p><span class="su-title">授权机构盖章：</span></p>
          <p><span class="su-title">被授权人签字：</span></p>
          <p><span class="su-title">日       期：</span><span class="enpty-bottom"></span>年<span class="enpty-bottom"></span>月<span class="enpty-bottom"></span>日</p>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
      name: "wordCustom",
      props: {
        // 是否中国内陆用户
        isInLand:{type: Boolean,default: true},
        //  法人
        license: {
          type: Object,
        },
        //被授权人
        grantAuth: {
          type: Object,
        }
      },
      data() {
          return {
            formRules: {
              enterpriseController11: [
                {required: true, message: '请输入被授权人姓名', trigger: 'blur'},
              ],
              bankLinkPhone11: [
                {required: true, message: '请输入被授权人联系电话', trigger: 'blur'},
                {validator: this.$validator.mobile, trigger: ['blur']},
              ],
              bankLinkEmail:[{required: true, message: '请输入被授权人联系邮箱', trigger: 'blur'},
                {validator: this.$validator.email, trigger: ['blur']},],
              IDCard11: [
                {required: true, message: '请输入被授权人身份证号', trigger: 'blur'},
                {validator: this.$validator.idCard, trigger: ['blur']},
              ],
            }
          }
      },
      mounted() {
          this.$refs.nameFocusRef.focus();
      },
      methods: {
        submit() {
          return new Promise((resolve, reject) => {
              this.$refs.formRef.validate(vaild => {
                if (vaild) {
                  resolve(1);
                } else {
                  resolve(0);
                }
              });
            });
          },
      }
    }
</script>

<style scoped lang="less">
  /deep/ .el-input--mini .el-input__inner {
    background-color: rgba(0,0,0,0.1);
  }
  /deep/ .el-form-item__error {
    top: 28%;
    left: 60%;
  }
  .word_box {
    .word_title {
      text-align: center;
      font-size: 22px;
      margin-bottom: 15px;
    }
    .word-end{
      display: flex;
      justify-content: flex-end;
      .sufix{
        width: 45%;
        .enpty-bottom{
          display: inline-block;
          width: 45px;
          border-bottom: 1px solid #000;
        }
        .su-title{
          display: inline-block;
          text-align: justify;
          width: 110px;
          text-align-last: justify;
        }
      }
    }
    .line-title{
      display: inline-block; 
      width: 200px;
      text-align: left;
    }
    .underline{
      display: inline-block;
      width: 360px;
      border-bottom: 1px solid #000;
    }
    .indent{
      text-indent: 2em;
    }
  }
</style>



// WEBPACK FOOTER //
// pages/auth/wordCustom.vue